"use client";

// Global flag to track if GTM is enabled
let gtmEnabled = false;

// Setter function to update GTM enabled state from context
export const setGtmEnabled = (enabled) => {
  gtmEnabled = enabled;
};

// Getter function to check if GTM is enabled
export const isGtmEnabled = () => gtmEnabled;

export const pushGtmEvent = (eventName, payload = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  // Only push event if GTM is enabled
  if (!gtmEnabled) {
    console.debug("GTM is disabled, event not pushed:", eventName);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};
